import { useCallback, useEffect, useRef, useState } from "react";

const SAVED_FLASH_MS = 2200;

/** A short-lived "saved" flag, set only after the server confirmed the change. */
export function useSavedFlash() {
  const [saved, setSaved] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(
    () => () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    },
    [],
  );

  const flash = useCallback(() => {
    setSaved(true);
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setSaved(false), SAVED_FLASH_MS);
  }, []);

  return { saved, flash };
}
